import React from 'react';
import styled from 'styled-components';

import css from 'css';
import SmartLink from 'partials/SmartLink';

export default ({ children, link, onClick, ...rest}) => {
    if(link) return <ButtonLink to={link} onClick={e => onClick ? onClick(e) : null} {...rest}>{children}</ButtonLink>
    if(!link) return <Button onClick={e => onClick ? onClick(e) : null} {...rest}>{children}</Button>
}

const buttonStyles = props => {
    return `
        cursor:pointer;
        outline: none;
        border: none;
        height:48px;
        display: inline-flex;
        align-items:center;
        padding:0 30px;
        background: ${css.colors.red};
        border: 2px solid ${css.colors.red};
        color: ${css.colors.main};
        font-size:18px;
        transition: all .1s ease-in-out;
        justify-content: center;
        &:hover {
            background: transparent;
        }
		&:visited, &:focus{
			color: inherit;
		}

		${props.blue ? `
			background: ${css.colors.blue};
			color: #fff;
			border: 2px solid ${css.colors.blue};
			&:hover {
				background: ${css.colors.main};
				color: #fff;
			}
			&:visited, &:focus{
				color: #fff;
			}
		` : ``}

        ${props.outline ? `
            background: transparent;
            &:hover {
                background: ${css.colors.red};
            }
        ` : ``}

        ${props.blue && props.outline ? `
            background: transparent;
            color: ${css.colors.main};
            border: 2px solid ${css.colors.blue};
            &:hover {
                background: ${css.colors.blue};
                color: #fff;
            }
			&:visited, &:focus{
				color: ${css.colors.main};
			}
        ` : ``}

        ${props.black ? `
            background: #000;
            color: #fff;
            border: 2px solid #000;
            &:hover {
                background: transparent;
                color: #000;
            }
			&:visited, &:focus{
				color: #fff;
			}
        ` : ``}

        ${props.main ? `
            background: ${css.colors.main};
            color: #fff !important;
            border: 2px solid ${css.colors.main};
            &:hover {
                background: transparent;
                color: ${css.colors.main} !important;
            }
			&:visited, &:focus{
				color: #fff !important;
			}
        ` : ``}

        ${props.main && props.outline ? `
            background: transparent;
            color: ${css.colors.main} !important;
            border: 2px solid ${css.colors.main};
            &:hover {
                background: ${css.colors.main};
                color: #fff !important;
            }
			&:visited, &:focus{
				color: ${css.colors.main} !important;
			}
        ` : ``}

        ${props.dark && props.outline ? `
            background: transparent;
            color: #000;
            border: 2px solid #000;
            &:hover {
                background: #000;
                color: #fff;
            }
			&:visited, &:focus{
				color: #000;
			}
        ` : ``}

        ${props.white ? `
            background: #fff;
            color: ${css.colors.main};
            border: 2px solid #fff;
            &:hover {
                background: transparent;
            }
			&:visited, &:focus{
				color: ${css.colors.main};
			}
        ` : ``}

        ${props.white && props.outline ? `
            background: transparent;
            color: #fff;
            border: 2px solid #ff;
            &:hover {
                background: #fff;
                color: ${css.colors.main} !important;
            }
			&:visited, &:focus{
				color: #fff; 
			}
			@media(max-width: 767px){
				color: #FFF !important;
				border: 2px solid #FFF;
			}
        ` : ``}

        ${props.pink ? `
            background: #FEEBEA;
            &:hover {
                background: transparent;
            }
        ` : ``}
    `;
}

const Button = styled.button`
    ${props => buttonStyles(props)}
`

const ButtonLink = styled(SmartLink)`
    ${props => buttonStyles(props)}
`



// WEBPACK FOOTER //
// ./src/partials/formElements/Button.js